export default [
    {
        path: 'exame-agendado-realizado',
        component: () => import(
            /* webpackChunkName: 'exame-laboratorial-exame-agendado-realizado' */
            '@/views/exame-laboratorial/exame-agendado-realizado/Index'
        ),
        redirect: 'exame-agendado-realizado/index',
        children: [
            {
                name: 'exame-laboratorial-exame-agendado-realizado-index',
                path: 'index',
                props: true,
                component: () => import(
                    /* webpackChunkName: 'exame-laboratorial-exame-agendado-realizado' */
                    '@/views/exame-laboratorial/exame-agendado-realizado/List.vue'
                ),
            },
            {
                name: 'exame-laboratorial-exame-agendado-realizado-create',
                path: 'create',
                props: true,
                component: () => import(
                    /* webpackChunkName: 'exame-laboratorial-exame-agendado-realizado' */
                    '@/views/exame-laboratorial/exame-agendado-realizado/Form.vue'
                ),
            },
        ],
    }
]